// Layout.js
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from "react-icons/io5";
import { MdContacts, MdDashboard } from "react-icons/md";
import { FaFileImage, FaSlidersH, FaSuitcaseRolling, FaQuoteLeft, FaVideo, FaMapMarkerAlt } from "react-icons/fa";
import { toast } from 'react-toastify';
import logo from '../asserts/hariomlogo.jpg'
import { getSocket } from './socket';

const NOTIFICATION_SOUND_URL = 'https://assets.mixkit.co/active_storage/sfx/933/933-preview.mp3';
const UNREAD_ENQUIRY_COUNT_KEY = 'unreadEnquiryCount';
const UNREAD_BOOKING_COUNT_KEY = 'unreadBookingCount';

const Layout = ({ children }) => {
    const [toggled, setToggle] = useState(false);
    const [openMenu, setOpenMenu] = useState(null); 
    const [unreadEnquiryCount, setUnreadEnquiryCount] = useState(() => {
        const savedCount = Number(localStorage.getItem(UNREAD_ENQUIRY_COUNT_KEY));
        return Number.isNaN(savedCount) ? 0 : savedCount;
    });
    const [unreadBookingCount, setUnreadBookingCount] = useState(() => {
        const savedCount = Number(localStorage.getItem(UNREAD_BOOKING_COUNT_KEY));
        return Number.isNaN(savedCount) ? 0 : savedCount;
    });
    const audioRef = useRef(null);
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    
    const lastSegment = pathname.split('/').pop();

    const playNotificationAlert = async () => {
        if (audioRef.current) {
            try {
                audioRef.current.currentTime = 0;
                await audioRef.current.play();
                return;
            } catch (error) {
                console.warn('Unable to play notification alert.', error);
            }
        }
    };

    useEffect(() => {
        let socket;
        const handleNewEnquiry = () => {
            toast.info('✨ New Khajuraho Enquiry Received!');
            setUnreadEnquiryCount((currentCount) => {
                const nextCount = currentCount + 1;
                localStorage.setItem(UNREAD_ENQUIRY_COUNT_KEY, String(nextCount));
                return nextCount;
            });
            playNotificationAlert();
        };

        const handleNewBooking = () => {
            toast.success('🚀 New Package Booking Received!');
            setUnreadBookingCount((currentCount) => {
                const nextCount = currentCount + 1;
                localStorage.setItem(UNREAD_BOOKING_COUNT_KEY, String(nextCount));
                return nextCount;
            });
            playNotificationAlert();
        };

        try {
            socket = getSocket();
        } catch (error) {
            console.warn('Unable to connect notification socket.', error);
            return undefined;
        }

        socket.on('new-enquiry', handleNewEnquiry);
        socket.on('new-booking', handleNewBooking);
        return () => {
            socket.off('new-enquiry', handleNewEnquiry);
            socket.off('new-booking', handleNewBooking);
        };
    }, []);

    useEffect(() => {
        if (pathname.includes('enquiries') && unreadEnquiryCount > 0) {
            localStorage.setItem(UNREAD_ENQUIRY_COUNT_KEY, '0');
            setUnreadEnquiryCount(0);
        }
        if (pathname.includes('bookings') && unreadBookingCount > 0) {
            localStorage.setItem(UNREAD_BOOKING_COUNT_KEY, '0');
            setUnreadBookingCount(0);
        }
    }, [pathname, unreadEnquiryCount, unreadBookingCount]);

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu); 
    };

    const logoutHandler = (e) => {
        e.preventDefault();
        dispatch(logout());
        navigate('/signin');
    };

    return (
        <div id="wrapper" className="d-flex">
            <audio ref={audioRef} preload="auto" className="d-none" src={NOTIFICATION_SOUND_URL}>
                <track kind="captions" src="" label="Notification sound" />
            </audio>
            
            {/* Sidebar */}
            <ul className={`navbar-nav sidebar accordion ${toggled ? 'toggled' : ''}`} id="accordionSidebar">
                <div className="adminlogo-container">
                    <Link to="/dashboard">
                        <img src={logo} alt='Khajuraho Routes' className='adminlogo' />
                    </Link>
                </div>

                {/* <div className="sidebar-heading">DASHBOARD NAVIGATION</div> */}

                <li className={`nav-item ${pathname === '/dashboard' ? 'active' : ''}`}>
                    <Link className="nav-link" to="/dashboard">
                        <MdDashboard />
                        <span>Dashbord</span>
                    </Link>
                </li>

                {/* <div className="sidebar-heading">MANAGEMENT</div> */}

 {/* Banner */}
                <li className={`nav-item ${pathname.includes('banners') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('banner')}
                    >
                        <FaSlidersH />
                        <span>Banners</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'banner' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/banners/add">Add Banner</Link>
                            <Link className="collapse-item" to="/khajuraho/banners">Banner List</Link>
                        </div>
                    </div>
                </li>

                {/* Tour Packages */}
                <li className={`nav-item ${pathname.includes('packages') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('kh-packages')}
                    >
                        <FaSuitcaseRolling />
                        <span>Tour Packages</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'kh-packages' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/packages/add">Add Package</Link>
                            <Link className="collapse-item" to="/khajuraho/packages">Packages List</Link>
                        </div>
                    </div>
                </li>

 {/* Services */}
                <li className={`nav-item ${pathname.includes('services') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('services')}
                    >
                        <FaSlidersH /> 
                        <span>Our Booklet
                        </span>
                    </Link>
                    <div className={`collapse ${openMenu === 'services' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/services/add">Add Booklet</Link>
                            <Link className="collapse-item" to="/khajuraho/services">Booklet List</Link>
                        </div>
                    </div>
                </li>

                {/* Enquiries */}
                <li className={`nav-item ${pathname.includes('enquiries') ? 'active' : ''}`}>
                    <Link className="nav-link notification-nav-link" to="/khajuraho/enquiries">
                        <MdContacts />
                        <span>Enquiries</span>
                        {unreadEnquiryCount > 0 && (
                            <span className="sidebar-notification-badge">
                                {unreadEnquiryCount > 99 ? '99+' : unreadEnquiryCount}
                            </span>
                        )}
                    </Link>
                </li>

                {/* Bookings */}
                <li className={`nav-item ${pathname.includes('bookings') ? 'active' : ''}`}>
                    <Link className="nav-link notification-nav-link" to="/khajuraho/bookings">
                        <FaSlidersH />
                        <span>Package Bookings</span>
                        {unreadBookingCount > 0 && (
                            <span className="sidebar-notification-badge">
                                {unreadBookingCount > 99 ? '99+' : unreadBookingCount}
                            </span>
                        )}
                    </Link>
                </li>

                {/* Gallery */}
                <li className={`nav-item ${pathname.includes('gallery') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('gallery')}
                    >
                        <FaFileImage />
                        <span>Gallery</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'gallery' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/gallery/add">Add Image</Link>
                            <Link className="collapse-item" to="/khajuraho/gallery">Gallery List</Link>
                        </div>
                    </div>
                </li>
                
                {/* Testimonials */}
                <li className={`nav-item ${pathname.includes('testimonials') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('testimonials')}
                    >
                        <FaQuoteLeft /> 
                        <span>Testimonials</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'testimonials' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/testimonials/add">Add Testimonial</Link>
                            <Link className="collapse-item" to="/khajuraho/testimonials">Testimonials List</Link>
                        </div>
                    </div>
                </li>
                
                {/* Videos */}
                <li className={`nav-item ${pathname.includes('videos') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('videos')}
                    >
                        <FaVideo /> 
                        <span>Short Videos</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'videos' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/videos/add">Add Video</Link>
                            <Link className="collapse-item" to="/khajuraho/videos">Videos List</Link>
                        </div>
                    </div>
                </li>
                
                {/* Visits */}
                <li className={`nav-item ${pathname.includes('visits') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('visits')}
                    >
                        <FaMapMarkerAlt /> 
                        <span>Khajuraho Places</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'visits' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/visits/add">Add Place</Link>
                            <Link className="collapse-item" to="/khajuraho/visits">Places List</Link>
                        </div>
                    </div>
                </li>

                {/* Blogs */}
                <li className={`nav-item ${pathname.includes('blogs') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('blogs')}
                    >
                        <FaSlidersH /> 
                        <span>Blogs</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'blogs' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/blogs/add">Add Blog</Link>
                            <Link className="collapse-item" to="/blogs">Blogs List</Link>
                        </div>
                    </div>
                </li>

                {/* Admins */}
                {/* <li className={`nav-item ${pathname.includes('admins') ? 'active' : ''}`}>
                    <Link
                        className="nav-link collapsed"
                        to="#"
                        onClick={() => toggleMenu('admins')}
                    >
                        <IoPersonCircleSharp /> 
                        <span>Manage Admins</span>
                    </Link>
                    <div className={`collapse ${openMenu === 'admins' ? 'show' : ''}`}>
                        <div className="collapse-inner py-2">
                            <Link className="collapse-item" to="/khajuraho/admins/add">Add Admin</Link>
                            <Link className="collapse-item" to="/khajuraho/admins">Admins List</Link>
                        </div>
                    </div>
                </li> */}

                <div className="mt-auto p-4 text-center">
                    <button 
                        className="btn btn-outline-warning btn-sm rounded-pill px-4" 
                        onClick={() => setToggle(!toggled)}
                        style={{ borderColor: 'var(--primary-gold)', color: 'var(--primary-gold)' }}
                    >
                        {toggled ? '→' : '← COLLAPSE'}
                    </button>
                </div>
            </ul>

            {/* Content Wrapper */}
            <div id="content-wrapper" className="d-flex flex-column flex-grow-1">
                <div id="content">
                    {/* Topbar */}
                    <nav className="navbar navbar-expand navbar-light topbar static-top px-4">
                        {/* <button onClick={() => setToggle(!toggled)} className="btn btn-link rounded-circle mr-3">
                            <i className="fa fa-bars" style={{ color: '#000' }}></i>
                        </button> */}
                        
                        <div className="mr-auto">
                            <h4 className="mb-0 font-weight-bold text-dark">
                                {lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1) || 'Dashboard'}
                            </h4>
                        </div>

                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item dropdown no-arrow">
                                <Link className="nav-link dropdown-toggle d-flex align-items-center" to="#" id="userDropdown" role="button" data-toggle="dropdown">
                                    <div className="text-right mr-3 d-none d-lg-inline">
                                        <div className="small font-weight-bold text-dark">Admin</div>
                                        {/* <div className="small text-muted" style={{ fontSize: '11px' }}>Khajuraho Routes</div> */}
                                    </div>
                                    <div className="rounded-circle p-1" style={{ border: '2.5px solid var(--primary-gold)', background: '#fff' }}>
                                        <IoPersonCircleSharp size={35} style={{ color: "var(--sidebar-blue)" }} />
                                    </div>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right shadow-lg border-0 animated--grow-in mt-2" style={{ borderRadius: '20px' }}>
                                    {/* <div className="px-4 py-4 border-bottom text-center">
                                        <h6 className="font-weight-bold mb-0">Admin</h6>
                                        <p className="small text-muted mb-0">admin@gmail.com</p>
                                    </div> */}
                                    <Link className="dropdown-item py-3 px-4 text-danger font-weight-bold" to="#" onClick={logoutHandler}>
                                        Logout
                                    </Link>
                                </div>
                            </li>
                        </ul>
                    </nav>

                    {/* Main Content Area */}
                    <div className="container-fluid py-4 px-4 fade-in">
                        {children}
                    </div>
                </div>

                {/* Footer */}
                {/* <footer className="bg-transparent py-4 mt-auto">
                    <div className="container-fluid px-5">
                        <div className="d-flex justify-content-between align-items-center small text-muted">
                            <div>© 2024 Khajuraho Routes Travel Services</div>
                            <div className="font-weight-bold" style={{ color: 'var(--primary-gold)' }}>Expert Version 2.0</div>
                        </div>
                    </div>
                </footer> */}
            </div>
        </div>
    );
};

export default Layout;
